import React from 'react'
import { Divider, Stack, Typography } from '@mui/material'

import ChargesTable from '../ChargesTable/ChargesTable'

import { PaymentMethodsSection } from '@/components/CreditTopOffModal/PaymentMethodsSection'
import useBillingSettings from '@/hooks/useBillingSettings'
import { useUserCharges } from '@/hooks/useUserCharges'

export default function BillingTabContent() {
  const billingSettingsHook = useBillingSettings()
  const { data: chargesData, isLoading: chargesLoading } = useUserCharges({ limit: 5 })
  const charges = chargesData?.charges || []

  return (
    <Stack gap="24px">
      {/* Header */}
      <Stack gap="4px">
        <Typography color="#101828" fontSize={18} fontWeight={600} lineHeight="28px">
          Billing
        </Typography>
        <Typography color="#475467" fontSize={14} lineHeight="20px">
          Manage your payment methods and billing information.
        </Typography>
      </Stack>
      <Divider sx={{ borderColor: '#EAECF0' }} />

      {/* Payment Methods Section */}
      <PaymentMethodsSection
        isBillingMode
        clientSecret={billingSettingsHook.clientSecret}
        creatingSetupIntent={billingSettingsHook.creatingSetupIntent}
        deletingPaymentMethodId={billingSettingsHook.deletingPaymentMethodId}
        isLoading={billingSettingsHook.loadingPaymentMethods}
        paymentMethods={billingSettingsHook.paymentMethods}
        selectedPaymentMethod={billingSettingsHook.selectedPaymentMethod}
        showAddCard={billingSettingsHook.showAddCard}
        title="Card Details"
        onAddPaymentMethod={billingSettingsHook.handleAddPaymentMethod}
        onCancelAddCard={billingSettingsHook.handleCancelAddCard}
        onDeletePaymentMethod={billingSettingsHook.handleDeletePaymentMethod}
        onPaymentMethodSelect={billingSettingsHook.handlePaymentMethodSelect}
        onSetupError={billingSettingsHook.handleSetupError}
        onSetupSuccess={billingSettingsHook.handleSetupSuccess}
      />
      <ChargesTable charges={charges} loading={chargesLoading} titleSize="md" />
      <Stack gap="24px" />
    </Stack>
  )
}
